module.exports = __webpack_public_path__ + "static/media/phone.472152aa.png";